import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=01364b43&"
import script from "./dispatch.vue?vue&type=script&lang=ts&"
export * from "./dispatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dispatch.vue"
export default component.exports